
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const ApprovalsApp24Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 24 24" width={24} height={24} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M11.78 1.72a.75.75 0 1 0-1.06 1.06L11.94 4a9 9 0 1 0 9.02 9.82.75.75 0 0 0-1.5-.13 7.5 7.5 0 1 1-7.52-8.19l-1.22 1.22a.75.75 0 0 0 1.06 1.06l2.5-2.5a.75.75 0 0 0 0-1.06l-2.5-2.5Zm4 8.5c.3.3.3.77 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l1.47 1.47 3.97-3.97c.3-.3.77-.3 1.06 0Z"
            fill="currentColor"
        />
    </svg>
}